<div class="info">
    <h1 *ngIf="existing != null">{{ 'edit' | translate }}</h1>
    <h1 *ngIf="existing == null">{{ 'add' | translate }}</h1>
    <div class="desc" *ngIf="query != null">
        <div class="desc-item">{{ 'line-direction-counters-resets.line' | translate }}: {{ query?.line }}</div>
        <div class="desc-item">{{ 'line-direction-counters-resets.direction' | translate }} : {{ query?.direction }}</div>
    </div>
</div>
<div class="table-scroll">
    <p-table class="reset-st-table" [value]="routes" [(selection)]="selectedRoutes" [scrollable]="true" scrollHeight="flex"
        styleClass="p-datatable-gridlines" [loading]="loading" selectionMode="multiple" dataKey="sequenceNumber">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col [style.width]="'60px' + ' !important'">
                <col [style.width]="'100px' + ' !important'">
                <col [style.width]="'500px' + ' !important'">
            </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="table-header"> {{ 'line-direction-counters-resets.do-reset' | translate | capitalizeFirst }} </th>
                <th class="table-header"> {{ 'line-direction-counters-resets.sequence-number' | translate | capitalizeFirst }} </th>
                <th class="table-header" style="display: flex; justify-content: space-between; align-items: center;">
                    <span>{{ 'line-direction-counters-resets.bus-stop' | translate | capitalizeFirst }}</span>
                    <div style="display: flex; gap: 20px;">
                        <button mat-raised-button color="sims" type="reset" (click)="handleFormClear()" [disabled]="existing == null">
                            {{'line-direction-counters-resets.delete' | translate | capitalizeFirst }}
                        </button>
                        <button mat-raised-button color="sims" type="submit" [disabled]="selectedRoutes?.length === 0 || !hasChanged"
                            (click)="handleFormSubmmited()">
                            {{'line-direction-counters-resets.save'| translate | capitalizeFirst }}
                        </button>
                    </div>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td class="table-cell">
                    <p-tableCheckbox [value]="toFormValue(rowData)"></p-tableCheckbox>
                </td>
                <td class="table-cell">{{ rowData?.sequenceNumber }}</td>
                <td class="table-cell">{{ rowData?.routeSegment?.stopPileBegin?.name }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>